import { render, staticRenderFns } from "./Lipstick.vue?vue&type=template&id=24c1cd50&scoped=true&"
import script from "./Lipstick.vue?vue&type=script&lang=js&"
export * from "./Lipstick.vue?vue&type=script&lang=js&"
import style0 from "./Lipstick.vue?vue&type=style&index=0&id=24c1cd50&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c1cd50",
  null
  
)

export default component.exports